var _rect, _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgInstafooter(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 40,
    height: 40,
    rx: 6,
    fill: "#2176FF"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M25 10H15C12.2386 10 10 12.2386 10 15V25C10 27.7614 12.2386 30 15 30H25C27.7614 30 30 27.7614 30 25V15C30 12.2386 27.7614 10 25 10Z",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M24.0002 19.3703C24.1236 20.2025 23.9815 21.0525 23.594 21.7993C23.2065 22.5461 22.5933 23.1517 21.8418 23.53C21.0903 23.9082 20.2386 24.0399 19.408 23.9062C18.5773 23.7726 17.81 23.3804 17.215 22.7855C16.6201 22.1905 16.2279 21.4232 16.0943 20.5925C15.9606 19.7619 16.0923 18.9102 16.4705 18.1587C16.8488 17.4072 17.4544 16.794 18.2012 16.4065C18.948 16.019 19.7979 15.8769 20.6302 16.0003C21.4791 16.1262 22.265 16.5218 22.8719 17.1286C23.4787 17.7355 23.8743 18.5214 24.0002 19.3703Z",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M25.5 14.5H25.51",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInstafooter);
export default __webpack_public_path__ + "static/media/instafooter.8257512ae21e072f4f62e8d702eb32d8.svg";
export { ForwardRef as ReactComponent };